<script setup>
import * as icons from "lucide-vue-next";
import { defineProps, defineEmits, computed, ref, onMounted } from "vue";

const props = defineProps({
  label: { type: String, required: true },
  disabled: { type: Boolean, default: false },
  handleClick: Function,
  font: { type: String, default: "font-medium" },
  rounded: { type: String, default: "rounded-md" },
  bgColor: {
    type: String,
    default: "bg-blue-600 hover:bg-blue-700 text-white",
  },
  shadow: { type: String, default: "shadow-md" },
  type: {
    type: String,
    default: "button",
  },
  textColor: {
    type: String,
    default: "text-gray-900",
  },
  icon: {
    type: String, // nome do ícone (ex: "Eye", "Search", "User")
    default: null,
  },
});

// seleciona dinamicamente o componente do ícone
const getIcon = () => {
  return props.icon && icons[props.icon] ? icons[props.icon] : null;
};
</script>

<template>
  <div class="mb-2">
    <button
      :type="props.type"
      :class="[
        'w-full outline-none  p-2.5 flex gap-2 items-center ',
        props.font,
        props.bgColor,
        props.rounded,
        props.shadow,
        props.textColor,
      ]"
      :disabled="props.disabled"
      @click="props.handleClick"
    >
      {{ props.label }}
      <component :is="getIcon()" v-if="getIcon()" class="w-4 h-4" />
    </button>
  </div>
</template>